const doubleSubmitErrorCode = 'E90010001';

const NonAlertPaymentErrorCodes = [doubleSubmitErrorCode];

export default NonAlertPaymentErrorCodes;



// WEBPACK FOOTER //
// ./src/constants/non-alert-payment-error-codes.js